<div class="imageContainer" [ngStyle]="style" (dblclick)="showImagesDialog($event)">
  <img [attr.src]="image ? image[size] : emptySource" [ngStyle]="imgStyle" alt="image uploaded"/>
  @if (mode == 'edit') {
    <i class="mdi mdi-circle-edit-outline mdi-24px pointer" (click)="showImagesDialog($event)"></i>
    <i class="mdi mdi-delete mdi-24px pointer p-error" (click)="confirmDelete($event)"></i>
    <i class="mdi mdi-plus-circle-outline mdi-48px pointer" (click)="showImagesDialog($event)"></i>
  }
</div>
